<template>
	<div v-loading.fullscreen.lock="loading">
		<banner></banner>
		<div class="wrap">
			<div class="inputIccid">
				<el-row>
					<el-col :sm="14" :xs="24">
						<el-form :model="ruleForm" ref="ruleForm">
							<el-form-item prop="iccid" :label="$i18n.locale=='zh'?'SIM卡卡号(ICCID)':'SIM卡卡號(ICCID)'" :rules="[{required: true, message: $t('inputIccid.rules.iccid1'), trigger: ['blur','change'] },{pattern: /^\d{19}$/, message: $t('inputIccid.rules.iccid2'), trigger: ['blur','change']},{max: 19, message: $t('inputIccid.rules.iccid2'), trigger: ['blur','change']}]">
								<el-input v-model="ruleForm.iccid" :placeholder="$i18n.locale=='zh'?'卡套背面条形码下方的19位数字，不含“F”':'卡套背面條形碼下方的19位數字，不含“F”'" class="form-control-el" ></el-input>
							</el-form-item>
						</el-form>
						<!-- <p class="noCard">{{$i18n.locale=='zh'?'没手机卡?点击这里':'沒手機卡？點擊這裡'}}<router-link :to="{name:'fillInfo',parmas:{}}">{{$t('btn.receive')}}</router-link></p> -->
						<p class="btnWrap"><a href="javascript:void(0)" class="btn_next" @click="submitForm">{{$t('btn.next')}}</a></p>
					</el-col>
					<el-col :sm="10" :xs="24" class="hidden-xs-only">
						<p class="img-iccid">
							<img src="../../static/images/img-iccid.jpg" v-if="$i18n.locale=='hk'"/>
							<img src="../../static/images/img-iccid-zh.jpg" v-if="$i18n.locale=='zh'"/>
						</p>
					</el-col>
				</el-row>
			</div>
			<!-- <rules></rules> -->
		</div>
		<footer>{{$t('footer')}}</footer>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import banner from '../components/banner'
import rules from '../components/rules'
import { checkIccid } from '@/api/api'
export default {
	name: 'inputIccid',
	components: {
		banner,
		rules,
	},
	data () {
		return {
			ruleForm:{
				iccid:''
			},
			loading:false
		}
	},
	computed: {
		...mapState('param',['gutter']),
		rules () {
			return {
				iccid: [
					{ required: true, message: 'iccid不能为空', trigger: 'change' },
					{ pattern: /^\d{19,19}$/,message: '请输入SIM card number( 卡片背后的19 位数字，不含“F”）', trigger: 'change' }
				]
			}
		},
		bundlecode () {
			return this.$route.query.bundlecode
		}
	},
	methods: {
		submitForm(){
			//console.log(this.ruleForm.iccid);
			this.$refs.ruleForm.validate((valid) => {
				if(valid){
					this.loading=true;
					checkIccid({iccid:this.ruleForm.iccid}).then(res=>{
						this.loading=false;
						console.log(res) 
						let _code = res.code;
						if(_code!=0){
							let _message = _code==1?this.$t('inputIccid.errMsg.code1'):(_code==2?this.$t('inputIccid.errMsg.code2'):(_code==3?this.$t('inputIccid.errMsg.code3'):(_code==5?this.$t('inputIccid.errMsg.code5'):'')))
							this.$msgbox({
								title: '提示',
								message:_message,
								showCancelButton: false,
								confirmButtonText: _code == 3?this.$t('btn.active'):this.$t('btn.sure'),
								confirmButtonClass: 'center',
								callback: action => {
									if(_code==5){
										this.$router.push({ name: 'index' });
									}
									if(_code==3){
										//window.location.href = 'https://www.ctexcel.com.hk/toActivate'
										window.open("https://www.ctexcel.com.hk/toActivate","_blank")
									}
								}
							})
						}else{
							//跳转并传递iccid
							this.$router.push({name:"payConfirm", query: {bundlecode: this.bundlecode}, params: {iccid: this.ruleForm.iccid}})
						}
					}).catch(error=>{
						this.loading=false;
						console.log(error);
					})
				}
			})
		}
	},
	created () {
		//如果直接进信息填写页面 默认 活动标识为 线上 offline
	  	window.sessionStorage.setItem('activeFlag', 'offline')
	  	this.$store.commit('param/setActiveFlag', sessionStorage.getItem('activeFlag'))
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
footer{
	text-align: center;
	line-height: 55px;
	font-size: 12px;
	color: #999;
}
@media (max-width:767px) {
	.wrap{
		padding: 0 20px;
	}
	.inputIccid{
		padding: 20px 0;
		p.noCard{
			text-align: center;
		}
		.btnWrap{
			text-align: center;
			.btn_next{
				margin-top: 20px;
				margin-bottom: 15px;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/inputIccid.vue